import BaseModel from '../base/BaseModel.model';
export default class Area extends BaseModel {
    public areaId?: number;
    public code?: string;
    public name?: string; 
    public description?: string;
    public isHistoryArea:Boolean | null;
    constructor(){
        super();
        this.init();
    }

    init(){
        this.areaId =0;
        this.isHistoryArea = false;
        this.code = "";
        this.name = "";
        this.description ="";
    }
}